module.exports = __webpack_public_path__ + "img/newest-shipments-no-data.46441a85.png";